module.exports = __webpack_public_path__ + "img/xiaolv.8a3f69fd.jpg";